import type { PaintOption } from '../types';

export const paintOptions: PaintOption[] = [
  { id: 'midnight-black', name: '미드나이트 블랙', hex: '#0b0d12', finish: 'metallic', price: 0 },
  { id: 'glacier-white', name: '글레이셔 화이트', hex: '#e8ebee', finish: 'pearl', price: 0 },
  { id: 'lunar-silver', name: '루나 실버', hex: '#a9adb4', finish: 'metallic', price: 600000 },
  { id: 'graphite-gray', name: '그라파이트 그레이', hex: '#4a4f57', finish: 'metallic', price: 600000 },
  { id: 'crimson-red', name: '크림슨 레드', hex: '#8f1220', finish: 'metallic', price: 1200000 },
  { id: 'deep-ocean-blue', name: '딥 오션 블루', hex: '#123a6b', finish: 'metallic', price: 1200000 },
  { id: 'forest-green', name: '포레스트 그린', hex: '#1f4a3a', finish: 'metallic', price: 1500000 },
  { id: 'sunset-orange', name: '선셋 오렌지', hex: '#d3561c', finish: 'matte', price: 1800000 },
];
